import type { Group, Mesh, SceneControl } from '@anov/3d-core'
import ObjectLayer from '../../Base/ObjectLayer'

export const StrategyManage = {
  circle: async () => (await import('./SingleCircle')).default,
  doubleCircle: async () => (await import('./DoubleCircle')).default,
  dynamicCircle: async () => ((await import('./DynamicCircle')).default),
}

export default class ParticleMesh extends ObjectLayer {
  _readyPromise: Promise<boolean>
  _mesh: Mesh
  _listeners = new Set()
  constructor(sceneControl: SceneControl) {
    super(sceneControl)
  }

  public get ready() {
    return this._readyPromise
  }

  public get mesh() {
    return this._mesh
  }

  public setupAnimation() {}

  // 注册监听
  public addReloadListener(callback) {
    this._listeners.add(callback)
  }

  // 移除监听
  public removeReloadListener(callback) {
    this._listeners.delete(callback)
  }

  // 销毁
  public destroy() {
    this._mesh.remove()
    this._mesh.removeFromParent()
    this._listeners.clear()
  }
}